import { twJoin } from 'tailwind-merge'

import { ProductBarcodeViewTriggerBadge, ProductCard as GeneralProductCard } from '@components/ProductCard'
import { Badge, BadgeWithDot } from '@components/designSystem/badges/badges'
import useTypedTranslation from '@hooks/useTypedTranslation.ts'

import type { ComponentProps, JSX } from 'react'

function ProductCard({ product, badges = [], utilities, ...rest }: ComponentProps<typeof GeneralProductCard>) {
  const { t } = useTypedTranslation()
  const aggregatedStockLevel = product.aggregateStockLevel('pessimistic')

  const stockLevelIndicatorClasses = twJoin(
    'absolute inset-y-0 left-0 w-1',
    aggregatedStockLevel === 'NO_STOCK' ? 'bg-no-stock' : 'bg-shelf-selected'
  )

  const myUtilities = utilities ? [...utilities] : []
  if (rest.isSelected) {
    myUtilities.push(<div className={stockLevelIndicatorClasses} key='indicator' />)
  }

  return (
    <GeneralProductCard
      product={product}
      badges={[
        product.baseCategory && <Badge size='sm' key='badge-cat'>{truncateCategory(product.baseCategory, 12)}</Badge>,
        product.reportedPrice && <Badge size='sm' key='badge-price'>{product.getPriceTag('reported')}</Badge>,

        aggregatedStockLevel === 'NO_STOCK' && <BadgeWithDot size='sm' color='outOfShelf' key='badge-oos'>{t('common.outOfStock')}</BadgeWithDot>,
        aggregatedStockLevel === 'UNKNOWN' && <BadgeWithDot size='sm' key='badge-unknown'>{t('common.unknownStock')}</BadgeWithDot>,

        <ProductBarcodeViewTriggerBadge product={product} key='badge-gtin'/>,
        ...badges,
      ].filter(Boolean) as JSX.Element[]}
      utilities={myUtilities}
      {...rest}
    />
  )
}

function truncateCategory(category: string, maxLength: number) {
  if (category.length < maxLength) return category
  return category.slice(0, maxLength) + '...'
}

export default ProductCard